import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./features/footer-pages/footer-pages.module').then((m) => m.FooterPagesModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
